import type { ReactNode } from "react";
import { useAuthStore } from "../../lib/auth/authStore";
import { LoginScreen } from "./LoginScreen";

/**
 * Renders `children` only when there's a live session; otherwise shows
 * the login screen. Expiry is checked against the persisted token's
 * `expiresAt`, so a stale token from localStorage doesn't slip through.
 */
export function AuthGate({ children }: { children: ReactNode }) {
	const token = useAuthStore((s) => s.token);
	const expiresAt = useAuthStore((s) => s.expiresAt);

	const authed =
		token != null && (expiresAt == null || Date.now() / 1000 < expiresAt);

	if (!authed) return <LoginScreen />;
	return <>{children}</>;
}
